import { render, staticRenderFns } from "./tenantGoals.vue?vue&type=template&id=409856d0&scoped=true&"
import script from "./tenantGoals.vue?vue&type=script&lang=js&"
export * from "./tenantGoals.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=409856d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409856d0",
  null
  
)

export default component.exports